import { createApp,h } from 'vue';
import Flow from "./vue/flow.vue";

const appFlow = "#flowApp";
if (document.querySelectorAll(appFlow).length) {

    var steps = document.querySelector(appFlow).dataset.steps;
    var dictionary = document.querySelector(appFlow).dataset.dictionary;
    var resultsGuideSteps = document.querySelector(appFlow).dataset.resultsguidesteps;

    const seedData = {
        steps: steps,
        dictionary: dictionary,
        resultsGuideSteps: resultsGuideSteps
    };

    const flow = createApp({
        data() {return seedData},
        render: ()=>h(Flow)
    },seedData);

    flow.mount(appFlow);
}
